import { render, staticRenderFns } from "./SlowMovingLocations.vue?vue&type=template&id=670bb3c1&"
import script from "./SlowMovingLocations.vue?vue&type=script&lang=js&"
export * from "./SlowMovingLocations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports